import { Helmet } from "react-helmet";
import SolutionsBody from "../components/solutions/SolutionsBody";
import PageHero from "../components/reusables/hero/PageHero";
import HowWeWork from "../components/solutions/HowWeWork";
import SolutionsWhyChoose from "../components/solutions/SolutionsWhyChoose";
import SolutionsNtunaCTA from "../components/solutions/SolutionsNtunaCTA";
import HomeTestimonials from "../components/home/HomeTestimonials";

export default function Solutions() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/solutions"
        />
        <meta
          name="description"
          content="Website, systems & app development, ICT Consultancy & equipment supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        
        <meta
          property="og:description"
          content="Website, systems & app development, ICT Consultancy & equipment supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta property="og:title" content="NTUNA.COM | Web & ICT Solutions" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | Web & ICT Solutions" />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Web & ICT Solutions"
        />
        <meta
          name="twitter:description"
          content="Website, systems & app development, ICT Consultancy & equipment supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Web & ICT Solutions</title>
      </Helmet>
      <PageHero
        classes="world-bg"
        titleClasses="title uppercase ntuna-text-fill"
        title="Solutions"
      />
      <SolutionsBody />
      <HowWeWork />
      <SolutionsWhyChoose />
      <HomeTestimonials />
      <SolutionsNtunaCTA />
    </>
  );
}
